import { ReaccreditationStatus } from 'components/pages/MyLearningV2/types/search';
import { CourseCard } from '../../components/pages/MyLearningV2/types/dashboard';
import {
  RouteCard,
  RouteType,
  RouteResourceType,
} from '../../components/pages/MyLearningV2/types/dashboard';

export const recentCoursesMock = [
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/1015568/pexels-photo-1015568.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Understanding the Fundamentals of Digital Marketing',
    module: 'Module 2',
    progress: 50,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/2041386/pexels-photo-2041386.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Crushing It with Digital Marketing: Simple Tips to Succeed!',
    module: 'Module 2',
    progress: 75,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/3153198/pexels-photo-3153198.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Planning a Digital Marketing Strategy',
    module: 'Module 1',
    progress: 25,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/34600/pexels-photo.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Social Media Marketing Essentials',
    module: 'Module 3',
    progress: 10,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/6476808/pexels-photo-6476808.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Email Marketing Strategies That Convert',
    module: 'Module 4',
    progress: 60,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/6693645/pexels-photo-6693645.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Content Marketing: Creating Value for Your Audience',
    module: 'Module 2',
    progress: 40,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/905163/pexels-photo-905163.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'SEO Fundamentals for Beginners',
    module: 'Module 5',
    progress: 85,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Analytics and Data-Driven Marketing',
    module: 'Module 6',
    progress: 15,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Building a Personal Brand Online',
    module: 'Module 3',
    progress: 30,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/3194519/pexels-photo-3194519.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Influencer Marketing: Partnerships That Work',
    module: 'Module 4',
    progress: 55,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/669615/pexels-photo-669615.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Mobile Marketing Strategies',
    module: 'Module 5',
    progress: 70,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/935979/pexels-photo-935979.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Marketing Automation Essentials',
    module: 'Module 6',
    progress: 20,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/4050315/pexels-photo-4050315.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Video Marketing: Creating Engaging Content',
    module: 'Module 7',
    progress: 45,
  },
];

export const nextCoursesMock = [
  {
    lp_id: null,
    lp_name: null,
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    course_name: 'Fundamentos del UX',
    description:
      'Fundamentos clave para implementar y gestionar auditoría y control interno efectivos asegurando la integridad y eficiencia de los procesos organizacionales.',
    start_date: '2025-05-30',
  },
  {
    lp_id: '07ec5012-a173-43a1-82a6-fc4d815b9475',
    lp_name: 'Carrera de Fundamentos de la Experiencia del Usuario',
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    course_name: 'Fundamentos de la Usabilidad Digital',
    description:
      'Claves para implementar y gestionar auditoría y control interno efectivos que aseguren la integridad y eficiencia de los procesos organizacionales.',
    start_date: '2025-06-06',
  },
  {
    lp_id: null,
    lp_name: null,
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    course_name: 'Diseño Centrado en el Usuario',
    // description: 'Explora los principios fundamentales del diseño centrado en el usuario, donde la experiencia del cliente es la prioridad. Aprende a crear soluciones efectivas que satisfagan las necesidades y expectativas de los usuarios.',
    start_date: '2025-08-25',
  },
  {
    lp_id: '9a4b8c3d-2e1f-5a6b-8c7d-9e0f1a2b3c4d',
    lp_name: 'Programa de Desarrollo Full Stack',
    id: 'c8d9e0f1-2a3b-4c5d-6e7f-8g9h0i1j2k3l',
    course_name: 'Introducción a React y TypeScript',
    description:
      'Domina los fundamentos de React junto con TypeScript para construir aplicaciones web modernas y tipadas. Aprenderás los conceptos clave de componentes, hooks y gestión de estado.',
    start_date: '2025-07-15',
  },
  {
    lp_id: null,
    lp_name: null,
    id: 'd1e2f3g4-5h6i-7j8k-9l0m-n1o2p3q4r5s',
    course_name: 'Análisis de Datos con Python',
    description:
      'Aprende a manipular, analizar y visualizar datos utilizando Python y sus principales librerías como Pandas, NumPy y Matplotlib. Curso práctico con casos reales.',
    start_date: '2025-09-01',
  },
  {
    lp_id: 'b5c6d7e8-9f0a-1b2c-3d4e-5f6g7h8i9j0',
    lp_name: 'Certificación en Cloud Computing',
    id: 'e5f6g7h8-i9j0-k1l2-m3n4-o5p6q7r8s9t',
    course_name: 'AWS Fundamentals',
    description:
      'Introducción completa a los servicios fundamentales de Amazon Web Services. Aprende sobre EC2, S3, RDS y más para construir arquitecturas en la nube.',
    start_date: '2025-07-30',
  },
];

export const streaksMock = {
  year: 2025,
  monthlyStreak: [
    {
      monthIndex: 1,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: true,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: true,
        },
      ],
    },
    {
      monthIndex: 2,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 3,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: true,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: true,
        },
        {
          weekIndex: 5,
          hasActivity: true,
        },
        {
          weekIndex: 6,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 4,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: true,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 5,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: true,
        },
        {
          weekIndex: 5,
          hasActivity: true,
        },
      ],
    },
    {
      monthIndex: 6,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: true,
        },
        {
          weekIndex: 3,
          hasActivity: true,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
        {
          weekIndex: 6,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 7,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 8,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 9,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 10,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 11,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
      ],
    },
    {
      monthIndex: 12,
      weeks: [
        {
          weekIndex: 1,
          hasActivity: false,
        },
        {
          weekIndex: 2,
          hasActivity: false,
        },
        {
          weekIndex: 3,
          hasActivity: false,
        },
        {
          weekIndex: 4,
          hasActivity: false,
        },
        {
          weekIndex: 5,
          hasActivity: false,
        },
      ],
    },
  ],
};

export const activeRoutesMock: RouteCard[] = [
  {
    routeType: RouteType.LEARNING_PATH,
    id: '07ec5012-a173-43a1-82a6-fc4d815b9475',
    img: 'https://images.pexels.com/photos/7376/startup-photos.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Digital Transformation Fundamentals',
    description:
      'Master the essentials of digital transformation and its impact on modern business.',
    progress: 75,
    endDate: '2024-03-15',
    approved: true,
    resources: [
      {
        id: 'c-001',
        name: 'Introduction to Digital Transformation',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-002',
        name: 'Change Management in Digital Era',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-003',
        name: 'Digital Strategy Implementation',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-004',
        name: 'Digital Strategy Implementation',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-005',
        name: 'Digital Strategy Implementation',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-006',
        name: 'Digital Strategy Implementation',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-007',
        name: 'Digital Strategy Implementation',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-008',
        name: 'Digital Strategy Implementation',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-009',
        name: 'Digital Strategy Implementation',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-010',
        name: 'Digital Strategy Implementation',
        resource_type: RouteResourceType.COURSE,
      },
    ],
  },
  {
    routeType: RouteType.LEARNING_PATH_COMPOSITE,
    id: '07ec5012-a173-43a1-82a6-fc4d815b9475',
    img: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Data Analytics Master Program',
    description:
      'Comprehensive program covering data analytics from basics to advanced applications.',
    progress: 50,
    endDate: '2024-02-28',
    approved: false,
    resources: [
      {
        id: 'r-001',
        name: 'Advanced Data Analytics',
        resource_type: RouteResourceType.LP_GROUP,
      },
      {
        id: 'r-002',
        name: 'Data Visualization Techniques',
        resource_type: RouteResourceType.LP_GROUP,
      },
    ],
  },
  {
    routeType: RouteType.LEARNING_PATH,
    id: '07ec5012-a173-43a1-82a6-fc4d815b9475',
    img: 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Agile Project Management',
    progress: 25,
    endDate: '2024-01-20',
    approved: false,
    resources: [
      {
        id: 'c-004',
        name: 'Agile Fundamentals',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-005',
        name: 'Scrum Master Essentials',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-006',
        name: 'Kanban Implementation',
        resource_type: RouteResourceType.COURSE,
      },
    ],
  },
  {
    routeType: RouteType.LEARNING_PATH,
    id: '07ec5012-a173-43a1-82a6-fc4d815b9475',
    img: 'https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Agile Project Management, The Revenge, Reloaded',
    progress: 33,
    approved: false,
    resources: [
      {
        id: 'c-004',
        name: 'Agile Fundamentals',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-005',
        name: 'Scrum Master Essentials',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-006',
        name: 'Kanban Implementation',
        resource_type: RouteResourceType.COURSE,
      },
    ],
  },
  {
    routeType: RouteType.LEARNING_PATH,
    id: '07ec5012-a173-43a1-82a6-fc4d815b9475',
    img: 'https://images.pexels.com/photos/3184393/pexels-photo-3184393.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Advanced Cloud Computing Architecture',
    description:
      'Comprehensive guide to designing, implementing and managing modern cloud infrastructure at scale.',
    progress: 75,
    endDate: '2024-03-15',
    approved: false,
    resources: [
      {
        id: 'c-101',
        name: 'Cloud Infrastructure Fundamentals',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-102',
        name: 'Microservices Architecture',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-103',
        name: 'Containerization and Orchestration',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-104',
        name: 'Cloud Security Best Practices',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-105',
        name: 'Serverless Computing',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-106',
        name: 'DevOps in the Cloud',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-107',
        name: 'Cloud Cost Optimization',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-108',
        name: 'High Availability Design',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-109',
        name: 'Disaster Recovery Planning',
        resource_type: RouteResourceType.COURSE,
      },
      {
        id: 'c-110',
        name: 'Cloud Performance Monitoring',
        resource_type: RouteResourceType.COURSE,
      },
    ],
  },
];

export const finishedCoursesMock: any[] = [
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Advanced JavaScript Programming',
    ownerName: 'Sarah Johnson',
    ownerImg: 'https://randomuser.me/api/portraits/women/44.jpg',
    hasReaccreditation: false,
    reaccreditationStatus: ReaccreditationStatus.INACTIVE,
    hasQualtrics: false,
    description:
      'Master modern JavaScript features, async programming, and advanced design patterns',
    approveDate: '2024-02-15',
    score: 92,
    isEnabledDc3: false,
    isEnabledDc3InCourse: false,
    dateToShowDC3: null,
    approved: true,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/3183165/pexels-photo-3183165.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Data Science Fundamentals',
    ownerName: 'Michael Chen',
    ownerImg: 'https://randomuser.me/api/portraits/men/32.jpg',
    description:
      'Introduction to data analysis, visualization, and machine learning basics',
    approveDate: '2024-01-28',
    hasReaccreditation: false,
    reaccreditationStatus: ReaccreditationStatus.INACTIVE,
    hasQualtrics: false,
    score: 85,
    isEnabledDc3: false,
    isEnabledDc3InCourse: false,
    dateToShowDC3: null,
    approved: true,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'UX Research Methods',
    ownerName: 'Emily Rodriguez',
    ownerImg: 'https://randomuser.me/api/portraits/women/68.jpg',
    description: 'Learn essential user research techniques and methodologies',
    approveDate: '2024-01-10',
    hasReaccreditation: false,
    reaccreditationStatus: ReaccreditationStatus.INACTIVE,
    hasQualtrics: true,
    score: 90,
    isEnabledDc3: false,
    isEnabledDc3InCourse: false,
    dateToShowDC3: null,
    approved: true,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Cloud Architecture Design',
    ownerName: 'David Smith',
    ownerImg: 'https://randomuser.me/api/portraits/men/76.jpg',
    description: 'Design scalable and resilient cloud infrastructure solutions',
    approveDate: '2023-12-20',
    hasReaccreditation: true,
    reaccreditationStatus: ReaccreditationStatus.ACTIVE,
    hasQualtrics: true,
    score: 95,
    isEnabledDc3: false,
    isEnabledDc3InCourse: false,
    dateToShowDC3: null,
    approved: true,
  },
  {
    id: 'b7a7d09f-4a2c-4a21-b176-2f526aacd82f',
    img: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    name: 'Agile Project Management',
    ownerName: 'Lisa Thompson',
    ownerImg: 'https://randomuser.me/api/portraits/women/90.jpg',
    description: 'Learn to lead projects using Scrum and Agile methodologies',
    approveDate: '2023-12-05',
    hasReaccreditation: true,
    reaccreditationStatus: ReaccreditationStatus.EXPIRED,
    hasQualtrics: true,
    score: 88,
    isEnabledDc3: false,
    isEnabledDc3InCourse: false,
    dateToShowDC3: null,
    approved: false,
  },
];

export const searchCardCoursesMock = {
  courses: [
    {
      id: '15148259-ba3d-4eaa-8ed2-87d9f6c846e3',
      name: 'curso externo verificar tipo de curso en reportes',
      description: 'asdadasdasd',
      imageUrl:
        'https://images.unsplash.com/photo-1502318217862-aa4e294ba657?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDZ8fHNwYWNlfGVufDB8fHx8MTczNjM0Mzk5Nnww&ixlib=rb-4.0.3&q=80&w=1080',
      type: 'EXTERNAL',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'INACTIVE',
      progress: 100,
      completedAt: '2025-01-20T18:06:28.406Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: false,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: '1233ecea-d4b1-4f3d-ad60-941a1b0b49f1',
      name: 'prueba francis nik',
      description: '',
      imageUrl:
        'https://images.unsplash.com/photo-1502691876148-a84978e59af8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDV8fGNvbG9yZnVsfGVufDB8fHx8MTc1MDEwNDE5OHww&ixlib=rb-4.1.0&q=80&w=1080',
      type: 'EXTERNAL',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-06-16T20:08:11.011Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: false,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: '3f0e077c-3105-48de-8bc2-6e41dabbe3fe',
      name: 'Evaluation Timer #02',
      description: null,
      imageUrl:
        'https://images.unsplash.com/photo-1506619216599-9d16d0903dfd?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDN8fG1pbmltYWx8ZW58MHx8fHwxNzUyNDk2NzAyfDA&ixlib=rb-4.1.0&q=80&w=1080',
      type: 'ONLINE',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-07-14T14:47:29.811Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: true,
      gamificationPoints: 100,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: '9321325d-4f3b-44f1-8397-255d7332ec4c',
      name: 'Course Automation 295582',
      description: null,
      imageUrl:
        'https://images.unsplash.com/photo-1431576901776-e539bd916ba2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDZ8fGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3MzcwNzEzMzB8MA&ixlib=rb-4.0.3&q=80&w=1080',
      type: 'ONLINE',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-06-04T15:28:51.652Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: true,
      gamificationPoints: 100,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: true,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: 'da45be4e-c11b-490a-93be-c22329d151a1',
      name: 'Course Automation 813043',
      description: null,
      imageUrl:
        'https://images.unsplash.com/photo-1431576901776-e539bd916ba2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDZ8fGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3MzcwNzEzMzB8MA&ixlib=rb-4.0.3&q=80&w=1080',
      type: 'ONLINE',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-06-04T15:32:30.903Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: true,
      gamificationPoints: 100,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: true,
      reaccreditationStatus: 'ACTIVE',
      hasQualtrics: true,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: '32cad6c3-21d0-46f5-a191-498b24acfd9d',
      name: 'Curso para marcar masivamente como completado 15',
      description: null,
      imageUrl:
        'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDMwfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzQ0NjQ5ODU3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      type: 'ONLINE',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'FAILED',
      progress: 100,
      completedAt: '2025-06-02T14:09:38.606Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: true,
      gamificationPoints: 100,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: true,
      reaccreditationStatus: 'EXPIRED',
      hasQualtrics: true,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: 'e49bf261-9f92-478d-b66d-b87c24715773',
      name: 'Copia - Curso acreditación 10 todos los tipos de lesson Test Performance 3',
      description: null,
      imageUrl:
        'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDMwfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzQ0NjQ5ODU3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      type: 'ONLINE',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-05-31T05:58:34.342Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: false,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: '21c87241-7d19-468f-9995-db868b0e5608',
      name: 'Curso para marcar masivamente como completado 12',
      description: null,
      imageUrl:
        'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDMwfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzQ0NjQ5ODU3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      type: 'ONLINE',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-05-30T21:44:26.225Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: false,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: '45083a15-825c-4a4f-83da-1ee5440f6c61',
      name: 'Curso para marcar masivamente como completado 13',
      description: null,
      imageUrl:
        'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDMwfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzQ0NjQ5ODU3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      type: 'ONLINE',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-05-30T23:27:45.933Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: false,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
    {
      id: '2e53255f-b130-4d48-85ab-ff275bd00f1e',
      name: 'Curso para marcar masivamente como completado 8',
      description: null,
      imageUrl:
        'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDMwfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzQ0NjQ5ODU3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      type: 'ONLINE',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-05-30T20:21:41.601Z',
      startDate: null,
      endDate: null,
      gamificationEnabled: false,
      catalogId: null,
      ownerName: 'Lapzo Team Platform',
      ownerImageUrl:
        'https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/assets%2Fclients%2Fteam%2Flogo_lapzo_color.png?alt=media&token=68d4a457-a904-4c4b-87c3-3e9defd9dc06',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      favorited: false,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
      isEnabledDc3: false,
      isEnabledDc3InCourse: false,
      dateToShowDC3: null,
    },
  ],
  total: 32,
};

export const searchCardRoutesMock = {
  routes: [
    {
      id: '328a05a2-500e-4a09-9e15-2052da354328',
      name: '4614 #02',
      description: 'Lorem',
      imageUrl: '',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'INACTIVE',
      progress: 100,
      completedAt: '2025-06-30T00:00:00.000Z',
      startDate: null,
      endDate: null,
      resources: [
        {
          id: '23dbbb75-ad2d-4e24-8d2b-bfb29f82e4fb',
          name: ' Administración del Proceso del Desarrollo Organizacional',
        },
      ],
      gamificationEnabled: false,
      gamificationPoints: null,
      matchCourses: [],
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'LP',
      favorited: false,
      lpcId: null,
    },
    {
      id: '93f8cf9b-fd6d-40c8-9560-fb340aa7bbef',
      name: 'Gamification Path #01',
      description: 'Lorem',
      imageUrl:
        'https://images.unsplash.com/photo-1454789548928-9efd52dc4031?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDJ8fHNwYWNlfGVufDB8fHx8MTc0OTA1MjE2NXww&ixlib=rb-4.1.0&q=80&w=1080',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2025-06-04T00:00:00.000Z',
      startDate: null,
      endDate: null,
      resources: [
        {
          id: '259143ee-2046-41bd-b894-e76145e23463',
          name: 'Course Automation 267576',
        },
        {
          id: '214cde3e-097c-48d4-95ce-5a8b4a88c24d',
          name: 'Course Automation 667627',
        },
      ],
      gamificationEnabled: true,
      gamificationPoints: 5000,
      matchCourses: [],
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'LP',
      favorited: false,
      lpcId: null,
    },
    {
      id: '8142a280-47a0-43e1-a31b-afdf13ed10d0',
      name: 'nikol 4378',
      description: 'nada ',
      imageUrl:
        'https://images.unsplash.com/photo-1454944338482-a69bb95894af?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDJ8fGZvb2R8ZW58MHx8fHwxNzMyNTUxMjk3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      clientId: '6732365d-5633-4c2f-b904-fbc410564eed',
      status: 'APPROVED',
      progress: 100,
      completedAt: '2024-11-25T00:00:00.000Z',
      startDate: null,
      endDate: null,
      resources: [
        {
          id: '574489e9-c4c8-4e6a-975e-7364a06b278f',
          name: 'lp prueba 1 ',
        },
        {
          id: '48256bfc-5dfd-4fb7-9147-7443ec50a137',
          name: 'lp prueba 2',
        },
        {
          id: 'd186e302-ea70-4035-8b4e-d99e680efae5',
          name: 'lp prueba 3',
        },
        {
          id: 'd4a4cd3a-be6d-4eb1-9d8b-f604850d2ceb',
          name: 'lp prueba 4',
        },
        {
          id: '208c8e0a-ed7a-4eef-802c-d2d3a2080402',
          name: 'lp prueba 5',
        },
      ],
      gamificationEnabled: true,
      gamificationPoints: 5000,
      matchCourses: [],
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'LP',
      favorited: false,
      lpcId: null,
    },
  ],
  total: 3,
};

export const searchTableContentMock = {
  allResources: [
    {
      id: '15148259-ba3d-4eaa-8ed2-87d9f6c846e3',
      name: 'curso externo verificar tipo de curso en reportes',
      type: 'EXTERNAL',
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      imageUrl:
        'https://images.unsplash.com/photo-1502318217862-aa4e294ba657?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDZ8fHNwYWNlfGVufDB8fHx8MTczNjM0Mzk5Nnww&ixlib=rb-4.0.3&q=80&w=1080',
      completedAt: '2025-01-20T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: true,
    },
    {
      id: '1233ecea-d4b1-4f3d-ad60-941a1b0b49f1',
      name: 'prueba francis nik',
      type: 'EXTERNAL',
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      imageUrl:
        'https://images.unsplash.com/photo-1502691876148-a84978e59af8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDV8fGNvbG9yZnVsfGVufDB8fHx8MTc1MDEwNDE5OHww&ixlib=rb-4.1.0&q=80&w=1080',
      completedAt: '2025-06-16T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: true,
      reaccreditationStatus: 'ACTIVE',
      hasQualtrics: true,
    },
    {
      id: '3f0e077c-3105-48de-8bc2-6e41dabbe3fe',
      name: 'Evaluation Timer #02',
      type: 'ONLINE',
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      imageUrl:
        'https://images.unsplash.com/photo-1506619216599-9d16d0903dfd?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDN8fG1pbmltYWx8ZW58MHx8fHwxNzUyNDk2NzAyfDA&ixlib=rb-4.1.0&q=80&w=1080',
      completedAt: '2025-07-14T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: true,
      reaccreditationStatus: 'EXPIRED',
      hasQualtrics: true,
    },
    {
      id: '328a05a2-500e-4a09-9e15-2052da354328',
      name: '4614 #02',
      type: null,
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'LP',
      imageUrl: '',
      completedAt: '2025-06-30T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: false,
      reaccreditationStatus: null,
      hasQualtrics: false,
    },
    {
      id: '93f8cf9b-fd6d-40c8-9560-fb340aa7bbef',
      name: 'Gamification Path #01',
      type: null,
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'LP',
      imageUrl:
        'https://images.unsplash.com/photo-1454789548928-9efd52dc4031?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDJ8fHNwYWNlfGVufDB8fHx8MTc0OTA1MjE2NXww&ixlib=rb-4.1.0&q=80&w=1080',
      completedAt: '2025-06-04T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: false,
      reaccreditationStatus: null,
      hasQualtrics: false,
    },
    {
      id: 'da45be4e-c11b-490a-93be-c22329d151a1',
      name: 'Course Automation 813043',
      type: 'ONLINE',
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      imageUrl:
        'https://images.unsplash.com/photo-1431576901776-e539bd916ba2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDZ8fGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3MzcwNzEzMzB8MA&ixlib=rb-4.0.3&q=80&w=1080',
      completedAt: '2025-06-04T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: true,
      reaccreditationStatus: 'ACTIVE',
      hasQualtrics: true,
      gamificationEnabled: true,
      gamificationPoints: 5000,
    },
    {
      id: '9321325d-4f3b-44f1-8397-255d7332ec4c',
      name: 'Course Automation 295582',
      type: 'ONLINE',
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      imageUrl:
        'https://images.unsplash.com/photo-1431576901776-e539bd916ba2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDZ8fGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3MzcwNzEzMzB8MA&ixlib=rb-4.0.3&q=80&w=1080',
      completedAt: '2025-06-04T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
    },
    {
      id: '32cad6c3-21d0-46f5-a191-498b24acfd9d',
      name: 'Curso para marcar masivamente como completado 15',
      type: 'ONLINE',
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      imageUrl:
        'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDMwfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzQ0NjQ5ODU3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      completedAt: '2025-06-02T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
    },
    {
      id: 'e49bf261-9f92-478d-b66d-b87c24715773',
      name: 'Copia - Curso acreditación 10 todos los tipos de lesson Test Performance 3',
      type: 'ONLINE',
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      imageUrl:
        'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDMwfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzQ0NjQ5ODU3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      completedAt: '2025-05-31T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
    },
    {
      id: '280e1049-3a7d-4470-af6c-8a2ccccc451e',
      name: 'Curso para marcar masivamente como completado 14',
      type: 'ONLINE',
      startDate: null,
      endDate: null,
      progress: 100,
      status: 'APPROVED',
      canUnsubscribe: false,
      canDownloadCertificate: true,
      contentType: 'COURSE',
      imageUrl:
        'https://images.unsplash.com/photo-1454391304352-2bf4678b1a7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDMwfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzQ0NjQ5ODU3fDA&ixlib=rb-4.0.3&q=80&w=1080',
      completedAt: '2025-05-30T00:00:00.000Z',
      favorited: false,
      lpcId: null,
      hasReaccreditation: false,
      reaccreditationStatus: 'INACTIVE',
      hasQualtrics: false,
    },
  ],
  total: 35,
};
